import { render, staticRenderFns } from "./ReporteVentaPeriodos.vue?vue&type=template&id=b814646a&scoped=true"
import script from "./ReporteVentaPeriodos.vue?vue&type=script&lang=js"
export * from "./ReporteVentaPeriodos.vue?vue&type=script&lang=js"
import style0 from "./ReporteVentaPeriodos.vue?vue&type=style&index=0&id=b814646a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b814646a",
  null
  
)

export default component.exports